{
  "abi": [
    {
      "type": "constructor",
      "inputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "addImplementation",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "implementation",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "defaultVersion",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "deployPaymaster",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "initData",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "deployPaymasterDeterministic",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "salt",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "initData",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "getImplementation",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "implementation",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getOperatorByPaymaster",
      "inputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getPaymasterByOperator",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getPaymasterCount",
      "inputs": [],
      "outputs": [
        {
          "name": "count",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getPaymasterInfo",
      "inputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "isValid",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getPaymasterList",
      "inputs": [
        {
          "name": "offset",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "limit",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "paymasters",
          "type": "address[]",
          "internalType": "address[]"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "hasImplementation",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "exists",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "hasPaymaster",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "implementations",
      "inputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "operatorByPaymaster",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "paymasterByOperator",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "paymasterList",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "predictPaymasterAddress",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "salt",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "outputs": [
        {
          "name": "predicted",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "registry",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IRegistry"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setDefaultVersion",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setRegistry",
      "inputs": [
        {
          "name": "_registry",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "totalDeployed",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "upgradeImplementation",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "newImplementation",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "event",
      "name": "DefaultVersionChanged",
      "inputs": [
        {
          "name": "oldVersion",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        },
        {
          "name": "newVersion",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ImplementationAdded",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "indexed": true,
          "internalType": "string"
        },
        {
          "name": "implementation",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ImplementationUpgraded",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "indexed": true,
          "internalType": "string"
        },
        {
          "name": "oldImplementation",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newImplementation",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PaymasterDeployed",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "paymaster",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "_version",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        },
        {
          "name": "timestamp",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "RegistryUpdated",
      "inputs": [
        {
          "name": "oldRegistry",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newRegistry",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "ERC1167FailedCreateClone",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ImplementationNotFound",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        }
      ]
    },
    {
      "type": "error",
      "name": "InitFailed",
      "inputs": [
        {
          "name": "returnData",
          "type": "bytes",
          "internalType": "bytes"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidImplementation",
      "inputs": [
        {
          "name": "implementation",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidInitData",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotRegisteredCommunity",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotRegisteredPaymasterAOA",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OperatorAlreadyHasPaymaster",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnerMismatch",
      "inputs": [
        {
          "name": "expected",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "actual",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "PaymasterNotFound",
      "inputs": [
        {
          "name": "paymaster",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ReentrancyGuardReentrantCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "VersionAlreadyExists",
      "inputs": [
        {
          "name": "_version",
          "type": "string",
          "internalType": "string"
        }
      ]
    }
  ],
  "bytecode": "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"
}
